var Handlebars = require("/home/jenkins/workspace/朵颐 - 发布POS前台/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {});

  return "<div class=\"showCatList item-list\">\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.showPageInfo : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.showPageInfo : depth0),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "    <div class=\"clearfix\"></div>\n"
    + ((stack1 = helpers.each.call(alias1,(depth0 != null ? depth0.categories : depth0),{"name":"each","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "</div>\n";
},"2":function(container,depth0,helpers,partials,data) {
    var alias1=container.lambda, alias2=container.escapeExpression;

  return "    <div style=\"display: inline-block;height: 50px;line-height:25px \">\n        <span class=\"itemPage\">\n             "
    + alias2(alias1((depth0 != null ? depth0.currentPage : depth0), depth0))
    + "/"
    + alias2(alias1((depth0 != null ? depth0.maxPage : depth0), depth0))
    + "\n        </span>\n    </div>\n";
},"4":function(container,depth0,helpers,partials,data) {
    var alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.escapeExpression;

  return "    <div class=\"pull-right btn-group paging vcenter\">\n        <button class=\"navbar-btn pageUp\">"
    + alias2(__default(require("/home/jenkins/workspace/朵颐 - 发布POS前台/src/hbHelpers/i18n.js")).call(alias1,"pos.order.previous",{"name":"i18n","hash":{},"data":data}))
    + "</button>\n        <button class=\"navbar-btn pageDown\">"
    + alias2(__default(require("/home/jenkins/workspace/朵颐 - 发布POS前台/src/hbHelpers/i18n.js")).call(alias1,"pos.order.next",{"name":"i18n","hash":{},"data":data}))
    + "</button>\n    </div>\n";
},"6":function(container,depth0,helpers,partials,data) {
    var alias1=container.lambda, alias2=container.escapeExpression;

  return "    <div class=\"item pitem cat\" data-catid=\""
    + alias2(alias1((depth0 != null ? depth0.id : depth0), depth0))
    + "\" data-index=\""
    + alias2(alias1((data && data.index), depth0))
    + "\">\n        <span>\n            "
    + alias2(alias1((depth0 != null ? depth0.name : depth0), depth0))
    + "\n        </span>\n    </div>\n";
},"8":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {});

  return "<div class=\"itemList item-list\">\n    <div style=\"display: inline-block;height: 50px;line-height:25px \">\n        <span class=\"itemInfo\">\n            "
    + container.escapeExpression(container.lambda((depth0 != null ? depth0.catName : depth0), depth0))
    + "\n        </span>\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.showPageInfo : depth0),{"name":"if","hash":{},"fn":container.program(9, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "    </div>\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.showPageInfo : depth0),{"name":"if","hash":{},"fn":container.program(4, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "    <div class=\"clearfix\"></div>\n"
    + ((stack1 = helpers.each.call(alias1,(depth0 != null ? depth0.menuItems : depth0),{"name":"each","hash":{},"fn":container.program(11, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "</div>\n";
},"9":function(container,depth0,helpers,partials,data) {
    var alias1=container.lambda, alias2=container.escapeExpression;

  return "        <span class=\"itemPage\">\n             "
    + alias2(alias1((depth0 != null ? depth0.currentPage : depth0), depth0))
    + "/"
    + alias2(alias1((depth0 != null ? depth0.maxPage : depth0), depth0))
    + "\n        </span>\n";
},"11":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.escapeExpression;

  return "    <div class=\"item pitem menuItem\">\n        <span class=\"itemNameSpan\">\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.showSoldOutStyle : depth0),{"name":"if","hash":{},"fn":container.program(12, data, 0, blockParams, depths),"inverse":container.program(14, data, 0, blockParams, depths),"data":data})) != null ? stack1 : "")
    + "        </span>\n        <span class=\"menuitem-price\">"
    + alias2(container.lambda((depths[1] != null ? depths[1].currencySymbol : depths[1]), depth0))
    + "&nbsp;"
    + alias2(__default(require("/home/jenkins/workspace/朵颐 - 发布POS前台/src/hbHelpers/toFixed.js")).call(alias1,(depth0 != null ? depth0.price : depth0),{"name":"toFixed","hash":{},"data":data}))
    + "</span>\n    </div>\n";
},"12":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression;

  return "                <span class=\"menuitem-wrapper menuitem-name sold-out\" data-id=\""
    + alias2(alias1((depth0 != null ? depth0.id : depth0), depth0))
    + "\" data-category-id=\""
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.category : depth0)) != null ? stack1.id : stack1), depth0))
    + "\"\n                      data-price=\""
    + alias2(alias1((depth0 != null ? depth0.price : depth0), depth0))
    + "\" data-parentid=\""
    + alias2(alias1((depth0 != null ? depth0.parentId : depth0), depth0))
    + "\">"
    + alias2(alias1((depth0 != null ? depth0.name : depth0), depth0))
    + " ("
    + alias2(__default(require("/home/jenkins/workspace/朵颐 - 发布POS前台/src/hbHelpers/i18n.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),"pos.setting.menu.menuItem.soldOut",{"name":"i18n","hash":{},"data":data}))
    + ")</span>\n\n";
},"14":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression;

  return "                <span class=\"menuitem-wrapper menuitem-name\" data-id=\""
    + alias2(alias1((depth0 != null ? depth0.id : depth0), depth0))
    + "\" data-category-id=\""
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.category : depth0)) != null ? stack1.id : stack1), depth0))
    + "\"\n                               data-price=\""
    + alias2(alias1((depth0 != null ? depth0.price : depth0), depth0))
    + "\" data-parentid=\""
    + alias2(alias1((depth0 != null ? depth0.parentId : depth0), depth0))
    + "\">"
    + alias2(alias1((depth0 != null ? depth0.name : depth0), depth0))
    + "</span>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1;

  return ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.showCat : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.program(8, data, 0, blockParams, depths),"data":data})) != null ? stack1 : "");
},"useData":true,"useDepths":true});


//////////////////
// WEBPACK FOOTER
// ./src/templates/order/MenuItemList.handlebars
// module id = 516
// module chunks = 0